
export const Archive = {
  onLoad: function() {
    if ($('body.blog').length // posts
     || $('body.category').length// posts category
     || $('.post-type-archive-event').length // event archive
     || $('body.post-type-archive-customer_story').length // customer story archive
     || $('body.tax-customer-story-category').length // customer story taxonomy content types
     || $('body.tax-industry').length // customer story taxonomy industries
     || $('body.post-type-archive-resource_hub').length // research & guide archive
     || $('body.tax-resource-hub-category').length // research & guide taxonomy content types
     || $('body.tax-roles').length) { // research & guide taxonomy roles
      this.initHeroSlider();
    }
  },
  initHeroSlider: function() {
    $('#hero-carousel').slick({
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots active-dot-color_white left-of-arrow',
    });
    $('#hero-carousel').css('visibility', 'visible');
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Archive.js